import Layout from '../../internal/Layout.vue'
import index from './index.vue'

const ScheduleRoutes = {
  component: Layout,
  children: [
    {
      name: 'slas',
      path: '/',
      component: index,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: false,
        requiresCoordSector: false,
        requiresLaboratory: true,
      },
    },
  ],
}

export default ScheduleRoutes
